import { ActionType } from './types'
import { Box } from '@jfs/ui-new'

const getDownloadView = (value: string, executeAction: (actionType: ActionType) => void) => {
  const download = () => {
    executeAction(ActionType.DownloadBulkFile)
  }
  return (
    <Box onPress={download} testID="DownloadBulkFile" disabled={value === '0'}>
      {value}
    </Box>
  )
}

export { getDownloadView }
